import { Field } from 'formik'
import React from 'react'
import { FormSectionTwoColumns } from '../../../../../../../../components/forms/FormSectionTwoColumns'
import { RichTextInput } from '../../../../../../../../components/inputs/RichTextInput/RichTextInput'
import { InfoPopover } from '../../../../../../../../components/InfoPopover'

interface Props {}

export const B2SpacialAndArchitecturalSolutions: React.FC<Props> = () => {
  return (
    <FormSectionTwoColumns sectionKey="b2.characteristics" title="">
      <div className="sm:col-span-6 flex flex-col gap-3">
        <Field
          name="b2.characteristics.compositionSolution"
          label="Kompozice prostorového řešení"
          aiHint="Kompozice prostorového řešení"
          component={RichTextInput}
          infoContent={
            <>
              <b>Kompozice prostorového řešení</b> by měla obsahovat stručný popis dispozičního a
              funkčního členění stavby, včetně uspořádání jednotlivých prostor a jejich propojení.
              Měl by uvádět účel hlavních částí objektu, orientaci vůči světovým stranám, vztah k
              okolnímu prostředí a základní informace o objemovém a výškovém řešení stavby. Celkové
              uspořádání by mělo být popsáno s ohledem na pohodlí uživatelů a harmonii s okolím.
            </>
          }
        />

        <div>
          <Field
            name="b2.characteristics.architecturalSolution"
            label="Základní architektonické řešení"
            aiHint="Základní architektonické řešení"
            component={RichTextInput}
            infoContent={
              <>
                <b>Základní architektonické řešení</b> by mělo obsahovat popis estetického,
                objemového a materiálového řešení stavby. Měl by uvádět tvar a proporce objektu,
                jeho harmonii s okolní zástavbou a urbanistickým kontextem, použití stavebních
                materiálů a barev, a řešení fasád, střechy a dalších viditelných prvků. Součástí
                může být i zmínka o souladu s požadavky na ochranu architektonických a kulturních
                hodnot, pokud se stavba nachází v citlivém území.
              </>
            }
          />
        </div>
      </div>
    </FormSectionTwoColumns>
  )
}
